import { cardListStyles } from "@insite/content-library/Widgets/SavedPayments/SavedPaymentsCardList";
import { GridOffset } from "@insite/mobius/GridContainer";
import { colorPalette, mediaQueriesBP } from "@waytek/Utilities/variables";
import { css } from "styled-components";

cardListStyles.headerContainer = {
    ...cardListStyles.headerContainer,

    css: css`
        margin-bottom: 16px;

        ${GridOffset} {
            ${mediaQueriesBP.minMD} {
                justify-content: space-between;
                align-items: center;
            }
        }
    `,
};

cardListStyles.titleGridItem = {
    ...cardListStyles.titleGridItem,

    css: css`
        ${mediaQueriesBP.minMD} {
            flex-basis: auto;
            max-width: none;
        }
    `,
};

cardListStyles.sortByGridItem = {
    ...cardListStyles.sortByGridItem,

    css: css`
        ${mediaQueriesBP.minMD} {
            flex-basis: auto;
            max-width: none;
        }
    `,
};

cardListStyles.sortBySelect = {
    ...cardListStyles.sortBySelect,

    cssOverrides: {
        formInputWrapper: css`
            ${mediaQueriesBP.minMD} {
                width: 190px;
            }
        `,
        formField: css`
            ${cardListStyles.sortBySelect?.cssOverrides?.formField}

            margin-bottom: 0;
        `,
    },
};

cardListStyles.cardHeaderWrapper = {
    ...cardListStyles.cardHeaderWrapper,

    css: css`
        ${cardListStyles.cardHeaderWrapper?.css}

        justify-content: flex-start;
        align-items: center;
    `,
};

cardListStyles.descriptionText = {
    ...cardListStyles.descriptionText,

    css: css`
        ${cardListStyles.descriptionText?.css}

        color: ${colorPalette.common.global.white};
        margin: 0 10px;
    `,
};

cardListStyles.cardTypeImage = {
    ...cardListStyles.cardTypeImage,

    css: css`
        flex: 0 0 48px;
    `,
};
